import { Component, OnInit } from '@angular/core';

import { GlobalService } from '../../../../services/global.service';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {

  constructor(
    public _globalService: GlobalService,
    public _chatService: ChatService
  ) { }

  ngOnInit() {
  }

  onEdit() {
    this._chatService.display_myprofile = false;
    this._chatService.display_edit_profile = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/chat/sub-components/my-profile/my-profile.component.ts